fx.ns("desktop.book.edition", class PhotoAnalyse extends fx.components.PopupPanel{
    
	constructor()
	{
		super();
		this.destroyOnSwitch = true;

        this.showEffect = "hslideout";
        this.hideEffect = "hslidein";

        this._photoIndex = 0;
        this._textIndex = 0;
	}

	create()
	{
        super.create();
       
		let box = new fx.components.Box();

		let circlesBox = new fx.components.Box("Person");

		this.personImage1 = new fx.components.Image({data : fx.get("assets").splashPhoto, className : "image"});
        this.personImage2 = new fx.components.Image({data : fx.get("assets").splashPhoto, className : "image"});
        
		this.processBar = new fx.components.RadialProgress({thickness: 10, color : "#a2d7eb", backgroundColor : "#fff", style:""});

		circlesBox.addChild(this.processBar, {width:240, height : 240, top : 10, left : "center"});
		circlesBox.addChild(this.personImage1);
        circlesBox.addChild(this.personImage2);

		box.addChild(circlesBox, {width:260, height : 260, top : 0, left : "center"});

		this.title = new fx.components.Text({text : fx.text("J'analyse vos photos"), className : "title center"});
		
		box.addChild(this.title, {width:"100%", height : 40, top : 280, left : "center"});

        this.iconCheck = new fx.components.Image({data: fx.get("assets").checkedIcon, className : "finished"});
        this.iconCheck.visibleAtStart = false;
		box.addChild(this.iconCheck, {width:60, height : 60, top : 330, left : "center"});
		this.iconCheck.effect = "scale";
		
		this.addChild(box, { width : 500, height : 350, top : "center", left : "center"});

	}

    onReady()
    {
        super.onReady();
        
        this.repeat(this._updatePhoto, 150);

        //this.on("analyse-finished", this._onAnalyseFinished, fx.service("AIService") );
       
        this.on("error-analyse", this._onErrorAnalyse, fx.service("AIService") );
        this.on("error-create", this._onErrorAnalyse, fx.service("AIService") );

        this.on("ready", this._onBookCreated, this.data.creator );
        
        if (!fx.service("AIService").processing)
            this._onAnalyseFinished();
    }

    _onBack()
    {
        this.hideEffect = "hslideout";
        this.data.event("previous-step");
    }


    get totalProgress()
    {
        return (fx.service("AIService").progress).toFixed(0);
    }

    _onAnalyseFinished()
    {
        if (!this.personImage1.cover)
            this.personImage1.cover = true;

        this.personImage1.css("z-index", this._photoIndex);
        this.processBar.blink(true);

        this.personImage2.hide();

        this.processBar.progress = 100;
        
        switch(this._textIndex)
        {
            case 0 :
            this.title.text = fx.text("Un Instant ...");
            this.personImage1.data = fx.get("assets").personAdvice;
            break;

            case 1 :
            this.title.text = fx.text("Je sélectionne les meilleures photos");
            this.personImage1.data = fx.get("assets").personAdvice;
            break;

            case 2 :
            this.title.text = fx.text("C'est presque bon !");
            this.personImage1.data = fx.get("assets").personThinking;
            break;

            default :
            this.title.text = fx.text("Je créé votre histoire ...");
            this.personImage1.data = fx.get("assets").personThinking;
            break;
        }

        this._textIndex++;
        this.delay(this._onAnalyseFinished, this._textIndex > 3 ? null : 4000);
    }


    _onErrorAnalyse()
    {
        // Let's use Chronological creator  
        this.data.placePhotosChronologically( this.data.photos.toArray() );
        this._onBookCreated();
    }

    _onBookCreated()
    {
        this.delay(this._onAnalyseFinished, null);

        this.iconCheck.show();
        this.personImage1.data = fx.get("assets").personSure;
		this.title.text = fx.text("Votre album est prêt !");

		this.data.event("show-editor", null, 2500);
    }
    
    // ------------------------------------------------- //
    _updatePhoto()
    {
        if (this.totalProgress == 100)
        {
            this.processBar.progress = this.totalProgress;
            this.repeat(this._updatePhoto, null);
            this._onAnalyseFinished();
            return;
        }

        let photo = this.data.photos.available.getItemAt(this._photoIndex++);

        if (photo)
        {
            if (this._photoIndex % 2)
            {
                if (!this.personImage1.cover)
                    this.personImage1.cover = true;

                this.personImage1.src = photo.thumb;
                this.personImage1.css("z-index", this._photoIndex);
            }
            else
            {
                if (!this.personImage2.cover)
                    this.personImage2.cover = true;

                this.personImage2.src = photo.thumb;
                this.personImage2.css("z-index", this._photoIndex);
            }
        }

        this.title.text = fx.text("J'analyse vos photos ($%)", this.totalProgress);
        this.processBar.progress = this.totalProgress;
        
        if (this._photoIndex >= this.data.photos.available.length)
            this._photoIndex = 0;

    }

    close()
    {
        super.close();

        if (fx.get("mode") == "creating-ia")
            this.data.event("navigate-back");
        else
            this.data.event("show-editor");
        
    }


});

	